import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayUseRequestDTO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly data: RoomBrandOverlayUseRequest) {
    JsonSchemaValidator.assert(RoomBrandOverlayUseRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      }
    };
  }
}

interface RoomBrandOverlayUseRequest {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
